/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteMiscSettingResponseData,
  GetSiteMiscSettingResponseDataFromJSON,
  GetSiteMiscSettingResponseDataFromJSONTyped,
  GetSiteMiscSettingResponseDataToJSON
} from './GetSiteMiscSettingResponseData'

/**
 *
 * @export
 * @interface UpdateSiteMiscSettingResponse
 */
export interface UpdateSiteMiscSettingResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateSiteMiscSettingResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteMiscSettingResponseData}
   * @memberof UpdateSiteMiscSettingResponse
   */
  data?: GetSiteMiscSettingResponseData
}

export function UpdateSiteMiscSettingResponseFromJSON(json: any): UpdateSiteMiscSettingResponse {
  return UpdateSiteMiscSettingResponseFromJSONTyped(json, false)
}

export function UpdateSiteMiscSettingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSiteMiscSettingResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteMiscSettingResponseDataFromJSON(json['data'])
  }
}

export function UpdateSiteMiscSettingResponseToJSON(value?: UpdateSiteMiscSettingResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteMiscSettingResponseDataToJSON(value.data)
  }
}
